import React, { useRef, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import html2pdf from "html2pdf.js";
import axios from "axios";
import "../Style/Bill.css";
import {BASE_URL} from "../Apis/apiConfig";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Bill = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const rawDataFromState = location.state?.record?.[0] || {};
  const billRef = useRef();
  const [styleContent, setStyleContent] = useState("");
  const society = localStorage.getItem("society") || "";
  const RegistrationNo = localStorage.getItem("societyRegNo") || "";
  const [rows, setRows] = useState([]);
  const [error, setError] = useState(null);
  const [memberBills, setMemberBills] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token") || "";
  const qs = new URLSearchParams(location.search);
  const memberIdFromQsRaw = qs.get("memberId") || "";
  const tableFromQs = qs.get("table") || qs.get("tableName") || "";
  const flatFromQs = qs.get("flat") || "";
  const nameFromQs = qs.get("name") || "";
  const billNoFromQs = qs.get("billNo") || qs.get("bill_no") || "";

  const tryExtractLeadingNumber = (s) => {
    if (!s) return "";
    const m = String(s).trim().match(/^(\d+)/);
    return m ? m[1] : "";
  };

  const derivedMemberId = (memberIdFromQsRaw && memberIdFromQsRaw.trim()) || tryExtractLeadingNumber(nameFromQs) || "";

  const [memberId, setMemberId] = useState(derivedMemberId);
  const [tableName, setTableName] = useState(tableFromQs || (society ? `${String(society).trim().toLowerCase().replace(/\s+/g, "_")}_bill` : ""));
  const [memberFlat, setMemberFlat] = useState(flatFromQs);
  const [memberName, setMemberName] = useState(nameFromQs);
  const rawData = Object.keys(rawDataFromState).length > 0 ? rawDataFromState : {};

  useEffect(() => {
    fetch("/Style/Bill.css")
      .then((res) => res.text())
      .then(setStyleContent)
      .catch((err) => console.error("CSS load error:", err));
  }, []);


  useEffect(() => {
    if (!society || !String(society).trim()) {
      setRows([]);
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const url = `${BASE_URL}/api/get-society-by-admin?societyName=${encodeURIComponent(
          society
        )}&registrationNo=${encodeURIComponent(RegistrationNo)}`;

        const response = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });

        setRows(Array.isArray(response.data) ? response.data : []);
      } catch (err) {
        console.error("Error fetching society details:", err);
        setError(err.response?.data || err.message || "Unknown error");
         toast.success("Error fetching society details:", {
                position: "bottom-right",
                autoClose: 3000,
      });
        setRows([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [society, RegistrationNo, token]);

  useEffect(() => {
    if (!society || !String(society).trim()) {
      setMemberBills([]);
      return;
    }
    const fetchBills = async () => {
      setLoading(true);
      setError(null);

      try {
        let url;
        if (billNoFromQs) {
          url = `${BASE_URL}/api/get-bill-by-billno?billNo=${encodeURIComponent(billNoFromQs)}&tableName=${encodeURIComponent(tableName)}`;
        } else {
          if (!memberId) {
            setMemberBills([]);
            setLoading(false);
            return;
          }
          url = `${BASE_URL}/api/get-bill-member?memberId=${encodeURIComponent(memberId)}&tableName=${encodeURIComponent(tableName)}`;
        }
        const response = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });

        setMemberBills(Array.isArray(response.data) ? response.data : (response.data ? [response.data] : []));
      } catch (err) {
        console.error("Error fetching member bills:", err);
        setError(err.response?.data || err.message || "Unknown error");
        setMemberBills([]);
      } finally {
        setLoading(false);
      }
    };

    fetchBills();
  }, [memberId, billNoFromQs, tableName, society, token]);
  const firstRow = rows && rows.length > 0 ? rows[0] : null;
  const addressParts = firstRow
    ? [
        firstRow.society_address,
        firstRow.society_address2,
        firstRow.society_address3,
        firstRow.society_area,
      ].filter(Boolean)
    : [];

  const addressString = firstRow
    ? (addressParts.join(", ") || "") + (firstRow.pin_code ? ` - ${firstRow.pin_code}` : "")
    : "";

  const phoneString = firstRow
    ? firstRow.contact_person_phone_no?.trim() || firstRow.contact_person?.trim() || ""
    : "";

  const charges = [
    { label: "Electricity Charges", value: rawData["Electricity_Chg."] },
    { label: "Insurance", value: rawData["Insurance"] },
    { label: "Maintenance Charges", value: rawData["Maintenance_Charges"] },
    { label: "Parking Charges - 2 Wheeler", value: rawData["Parking_Charges_2_Wheeler"] },
    { label: "Parking Charges - 3&4 Wheeler", value: rawData["Parking_Charges-_3&4_Wheeler"] },
    { label: "Repair Fund - External Repair Only", value: rawData["Repair_Fund-_External_Repair_Only"] },
    { label: "Sinking Fund", value: rawData["Sinking_Fund"] },
    { label: "Water Charges", value: rawData["Water_Charges"] },
    { label: "Non Occupancy Charges", value: rawData["Non_Occupancy_Charges"] },
    { label: "Principal Arrears", value: rawData["Principal_Arrears"] },
    { label: "Interest / Late Fee", value: rawData["Interest/Late_Fee"] },
  ].filter(item => item.value != null && String(item.value).trim() !== "");

  const formatAmount = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n.toFixed(2) : "0.00";
  };

  const handleDownloadPDF = () => {
    const element = document.createElement("div");
    element.innerHTML = `\n      <style>${styleContent}</style>\n      ${billRef.current ? billRef.current.innerHTML : ""}\n    `;

    const opt = {
      margin: 0.5,
      filename: `Maintenance_Bill_${rawData["Bill_No."] || "Bill"}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 3 },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };

    html2pdf().set(opt).from(element).save();
  };

  const handleDelete = () => {
    if (window.confirm("Are you sure you want to delete this bill?")) {
       toast.error("Bill deleted (simulated).", {
                position: "bottom-right",
                autoClose: 3000,
      });

      navigate("/dashboard");
    }
  };
  const displayName = memberName || rawData["Member_Name"] || "";
  const displayFlat = (memberFlat || rawData["Flat_No"] || rawData["Member_Name"]?.split(" ")?.[0] || "").toString();


   useEffect(() => {
     const societyName = localStorage.getItem("society")
    if (!society || !String(society).trim()) {
      setMemberBills([]);
      return;
    }
    const fetchBills = async () => {
      setLoading(true);
      setError(null);

      try {
        let url;
        if (billNoFromQs) {
          url = `${BASE_URL}/api/get-bill-by-billno?memberName=${encodeURIComponent(memberName)}&societyName=${encodeURIComponent(societyName)}`;
        } else {
          if (!memberId) {
            setMemberBills([]);
            setLoading(false);
            return;
          }
          url = `${BASE_URL}/api/get-bill-member?memberName=${encodeURIComponent(memberName)}&societyName=${encodeURIComponent(societyName)}`;
        }
        const response = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });

        setMemberBills(Array.isArray(response.data) ? response.data : (response.data ? [response.data] : []));
      } catch (err) {
        console.error("Error fetching member bills:", err);
        setError(err.response?.data || err.message || "Unknown error");
        setMemberBills([]);
      } finally {
        setLoading(false);
      }
    };

    fetchBills();
  }, [memberId, billNoFromQs, tableName, society, token]);
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", margin: "10px 20px" }}>
        <button onClick={handleDownloadPDF} className="download-btn">📥 Download PDF</button>
        <button onClick={handleDelete} className="delete-btn">❌ Delete</button>
      </div>

      <div className="bill-container" ref={billRef}>
        <div className="bill-header">
          <h2>{society}</h2>
          <p>Registration No. {RegistrationNo}</p>

          {loading ? (
            <p>Loading society details…</p>
          ) : error ? (
            <p style={{ color: "crimson" }}>Error loading society details: {String(error)}</p>
          ) : firstRow ? (
            <>
              <p><strong></strong> {addressString} {phoneString}</p>
            </>
          ) : (
            <p>No society details found.</p>
          )}
        </div>

        <div className="bill-info">
          <div>
            <p><strong>Name:</strong> {displayName}</p>
            <p><strong>Flat No.:</strong> {displayFlat}</p>
            <p><strong>Bill No.:</strong> {rawData["Bill_No."] || rawData["Bill_No"] || rawData["BillNo"] || ""}</p>
          </div>
          <div>
            <p><strong>Bill Date:</strong> {rawData["Bill_Date"] || ""}</p>
            <p><strong>Area (Sq.Ft.):</strong> 740</p>
            <p><strong>Due Date:</strong> -</p>
          </div>
          <div>
            <p><strong>Bill For:</strong> Apr - Jun 2024</p>
          </div>
        </div>

        <table className="charges-table">
          <thead>
            <tr>
              <th>Sr No.</th>
              <th>Particulars of Charges</th>
              <th>Amount (₹)</th>
            </tr>
          </thead>
          <tbody>
            {charges.map((item, i) => (
              <tr key={i}>
                <td>{i + 1}</td>
                <td>{item.label}</td>
                <td>{formatAmount(item.value)}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="totals-section">
          <p><strong>Rupees {formatAmount(rawData["Total_Amount"]) } Only</strong></p>
          <table>
            <tbody>
              <tr><td>Total</td><td>₹ {formatAmount(rawData["Sub_Total"])}</td></tr>
              <tr><td>Add: Interest</td><td>₹ {formatAmount(rawData["Interest/Late_Fee"])}</td></tr>
              <tr><td>Less: Adjustment</td><td>₹ 0.00</td></tr>
              <tr><td>Arrears</td><td>₹ {formatAmount(rawData["Principal_Arrears"])}</td></tr>
              <tr className="grand-total">
                <td><strong>Amount Due</strong></td>
                <td><strong>₹ {formatAmount(rawData["Total_Amount"])}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="notes">
          <p>1. For delayed payments, an interest of 21% per annum shall be levied for the arrears (up to date of default).</p>
          <p>2. Cheque/DD Payments in favour of "Spring Leaf 5 CHS LTD"</p>
          <p>3. For NEFT/RTGS: Beneficiary: Spring Leaf 5 CHS Ltd, Bank: PUNJAB NATIONAL BANK, A/c No: XXXXXXXX, IFSC: XXXXXXX</p>
          <p>4. Society is not responsible for wrong/delayed credits without these details.</p>
          <p>5. For bill clarification, please contact the Manager at the Society Office.</p>
        </div>

        <hr />

        <div className="payment-history">
          <h3>PAYMENT RECEIPT</h3>
          <p>Received with Thanks from <strong>{displayName}</strong></p>
          <table>
            <thead>
              <tr>
                <th>Receipt No.</th>
                <th>Date</th>
                <th>Cheque No.</th>
                <th>Bank Name</th>
                <th>Amount (₹)</th>
              </tr>
            </thead>
            <tbody>
              <tr className="grand-total">
                <td colSpan="4"><strong>Total Rs.</strong></td>
                <td><strong>₹ {formatAmount(rawData["Total_Amount"])}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="signature">
          <p>THIS IS A COMPUTER GENERATED BILL AND DOES NOT REQUIRE ANY SIGNATURE.</p>
          <p>For {society}</p>
          <p className="signed">sd/-<br />Authorised Signatory</p>
        </div>
      </div>
    </div>
  );
};

export default Bill;
